module.exports = __webpack_public_path__ + "pc/img/rec_05.891ed1a0.svg";